var map = {
	"./monster-1.png": 1652,
	"./monster-2.png": 1653,
	"./monster-23.png": 1654,
	"./monster-3.png": 1655,
	"./monster-4.png": 1656,
	"./monster-5.png": 1657,
	"./monster-6.png": 1658,
	"./monster-7.png": 1659,
	"./monster-8.png": 1660,
	"./monster-9.png": 1661
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;



//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters ^\.\/monster\-.*\.png$
// module id = 667
// module chunks = 0